export const KeyboardKey = {
   Enter: "Enter",
   Escape: "Escape",
   Space: " ",
   Tab: "Tab",
   ArrowDown: "ArrowDown",
   ArrowUp: "ArrowUp",
   ArrowRight: "ArrowRight",
   ArrowLeft: "ArrowLeft",
} as const;

export type KeyboardKey = (typeof KeyboardKey)[keyof typeof KeyboardKey];

export const KeyCode = {
   TAB: 9,
   ENTER: 13,
} as const;

export type KeyCode = (typeof KeyCode)[keyof typeof KeyCode];
